/// <amd-module name="Build/Run/Components/TestStatus" />
import * as React from "react";

import * as Resources from "Build/Run/Resources";
import { IRunExternalService } from "Build/Run/RunExternalService";
import { usePromise } from "VSS/Core/Util/Promise";

import { TestReportDataParser } from "Test/common-util/Common.Utils";

import { BaseStatus, IBaseStatusOptions } from "Build/Run/Components/BaseStatus";

import { format } from "VSS/Core/Util/String";
import { useComponentContext } from "VSS/Platform/Layout";
import { TimelineRecordState } from "Build/Client/Contracts/Build";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";

interface IStageData {
    buildId: number;
    stage: string;
}

interface ITestStatusProps extends IBaseStatusOptions {
    stageData: IStageData;
    recordState: TimelineRecordState;
}

export const TestStatus: React.FunctionComponent<ITestStatusProps> = props => {
    const context = useComponentContext();
    const [text, setText] = React.useState("");
    const { trackPromise } = usePromise();
    const externalService = context.pageContext.getService<IRunExternalService>("IRunExternalService");
    const LimitGetTestPipelineMetrics = isFeatureFlagEnabled(context.pageContext, "WebAccess.TestManagement.Server.LimitGetTestPipelineMetrics", false);

    if (LimitGetTestPipelineMetrics) {
        React.useEffect(() => {
            const stageData = props.stageData;
            trackPromise(externalService.getTestsResultsForStage(stageData.buildId, stageData.stage).then(data => {
                if (data && data.testsCount > 0) {
                    setText(format(Resources.TestResultPassedFormat, format(Resources.TestResultTestsFormat, TestReportDataParser.getCustomizedDecimalValueInCurrentLocale(data.testsPassRate, 1))));
                }
            }));
        }, [props.stageData.buildId, props.stageData.stage, props.recordState]); 
    } else {
        React.useEffect(() => {
            const stageData = props.stageData;
            trackPromise(externalService.getTestsResultsForStage(stageData.buildId, stageData.stage).then(data => {
                if (data && data.testsCount > 0) {
                    setText(format(Resources.TestResultPassedFormat, format(Resources.TestResultTestsFormat, TestReportDataParser.getCustomizedDecimalValueInCurrentLocale(data.testsPassRate, 1))));
                }
            }));
        }, [props.stageData]);
    }

    return <BaseStatus text={text} href={externalService.getTestTabLink(props.stageData.buildId)} iconName="TestBeaker" onData={props.onData} />;
}